import angular from "angular";
angular.module("cardspotWeb.areas.lookupCard", ["angularUtils.directives.dirPagination"]);